import React from "react";
import WiresActivityPage, { getDefaultData, getDefaultUI } from "components/pages/WiresActivityPage";
import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { WireActivity } from "model";
import FedWiresPage from "components/pages/FedWiresPage";

/**
 * @name Capture004WireHistory
 * @returns {React.Component}
 * @description - A capture in capture group "Wire Activity".
 */
export default function Capture004WireHistory() {
  
    return <FedWiresPage />;
}